import { Flex, Typography } from "antd"
import classname from "classname"
import dayjs from "dayjs"
import { useDispatch } from "react-redux"

import Icon from "../../../../../Icon"
import UserCreators from "../../../../User/reducer"
import StatusTagSimple from "../StatusTagSimple/StatusTagSimple"

import styles from "./RequestInfoModal.module.less"

const { Text, Link } = Typography

const RequestInfo = ({ request }) => {
  const dispatch = useDispatch()

  const handleBusinessAccountClick = () => {
    const business_account_id = request?.business_account?.id
    if (business_account_id) {
      dispatch(UserCreators.userSetProp("admin_selected_business_account_id", business_account_id))
      window.open(`${process.env.REACT_APP_BASE_URI}/business_settings/enrollment`)
    }
  }

  const createdDate = request?.created
    ? dayjs(request?.created).format("DD MMM, YYYY h:mm A [(UTC)]")
    : "-"
  const updatedDate = request?.updated
    ? dayjs(request?.updated).format("DD MMM, YYYY h:mm A [(UTC)]")
    : "-"
  return (
    <Flex gap={16} vertical className={styles.requestInfo}>
      <div className={styles.firstBlock}>
        <Flex vertical gap={4}>
          <Text type="secondary" strong>
            Status
          </Text>
          {request?.status ? (
            <div>
              <StatusTagSimple status={request?.status} />
            </div>
          ) : (
            <Text>-</Text>
          )}
        </Flex>
        <Flex vertical gap={4}>
          <Text type="secondary" strong>
            Business Account
          </Text>
          <Link onClick={handleBusinessAccountClick} disabled={!request?.business_account?.id}>
            {request?.business_account?.name || "-"}
          </Link>
        </Flex>
        <Flex vertical gap={4}>
          <Text type="secondary" strong>
            Request date
          </Text>
          <Text strong>{createdDate}</Text>
        </Flex>
        <Flex vertical gap={4}>
          <Text type="secondary" strong>
            Update status date
          </Text>
          <Text strong>{updatedDate}</Text>
        </Flex>
      </div>
      {request?.rejection_reason && <RejectionReasonAlert reason={request?.rejection_reason} />}
      {request?.logs && <RequestLogs logs={request?.logs} />}
    </Flex>
  )
}

const RejectionReasonAlert = ({ reason }) => {
  return (
    <div className={styles.rejectionReasonAlert}>
      <Icon className={styles.icon} type="triangle_exclamation2" />
      <Text>
        <Text strong>Rejection reason</Text> - {reason}
      </Text>
    </div>
  )
}

const RequestLogs = ({ logs }) => {
  return (
    <Flex vertical className={styles.requestLogs}>
      <Flex gap={16} className={classname(styles.row, styles.headerRow)}>
        <div className={styles.adminColumn}>
          <Text type="secondary" strong>
            Admin
          </Text>
        </div>
        <div className={styles.firstColumn}>
          <Text type="secondary" strong>
            Event
          </Text>
        </div>
        <div className={styles.secondColumn}>
          <Text type="secondary" strong>
            Date and time{" "}
          </Text>
        </div>
      </Flex>
      {logs?.map((log) => (
        <RequestLogRow log={log} key={log?.created} />
      ))}
    </Flex>
  )
}

const RequestLogRow = ({ log }) => {
  return (
    <Flex gap={16} className={styles.row}>
      <div className={styles.adminColumn}>
        <Text strong>{log?.admin_name || "-"}</Text>
      </div>
      <div className={styles.firstColumn}>
        <Text strong>{log?.log_message}</Text>
      </div>
      <div className={styles.secondColumn}>
        <Text strong>
          {log?.created ? dayjs(log?.created).format("DD MMM, YYYY h:mm A [(UTC)]") : "-"}
        </Text>
      </div>
    </Flex>
  )
}

export default RequestInfo
